import React from "react";
import { IAdditional } from "../TableTemplate/tableTemplate";
import {
  ConnectionStatus,
  IConnectionsReport,
} from "../../Interfaces/connections";
import { TableCell } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import SimpleTextInput from "../../Components/SimpleTextInput";
import {
  checkConnection,
  enterCaptcha,
  getNewCaptcha,
  logoutConnection,
} from "../../Requests/connections";
import { toast } from "react-toastify";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import Button from "../../Components/Button";
import { decrementSeconds } from "../../helper";
import { apiAddress } from "../../Requests/config";
import { setSahraConnectionsTableFetchDataFlag } from "../../Features/SahraConnections/SahraConnectionsSlice";
import { useAppDispatch } from "../../App/hooks";
import {
  disableSahraUserTrade,
  enableSahraUserTrade,
} from "../../Requests/Sahra/sahraUsersRequests";
import { packetErrorHandler } from "../../Utils/requestUtils";
import ToggleSwitch from "../../Components/ToggleSwitch";

const ConnectionTableAdditionalHeader: React.FC = () => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">زمان</span>
      </TableCell>
      <TableCell>
        <span className="!font-black text-black">کپچا</span>
      </TableCell>
      <TableCell></TableCell>
      <TableCell>
        <span className="!font-black text-black">ورود کپچا</span>
      </TableCell>
      <TableCell></TableCell>
      <TableCell>
        <span className="!font-black text-black">پیام</span>
      </TableCell>
      <TableCell>
        <span className="!font-black text-black">قابلیت معامله</span>
      </TableCell>
    </>
  );
};

const SahraUsersAdditionalCol: React.FC<{
  row: IConnectionsReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [captcha, setCaptcha] = React.useState<string>("");
  const [loading, setLoading] = React.useState(false);
  const [time, setTime] = React.useState(getTime(row.time));

  const dispatch = useAppDispatch();

  function getTime(time: string) {
    const timeParts = time.split(":");

    return `${timeParts[1]}:${timeParts[2]}:${timeParts[3]}`;
  }

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(decrementSeconds(time));
    }, 1000);
    return () => clearInterval(intervalId);
  }, [time]);

  React.useEffect(() => {
    if (row.estimated) {
      setCaptcha(row.estimated);
    }
  }, [row]);

  const getNewCaptchaHandler = () => {
    setLoading(true);
    getNewCaptcha(row.id)
      .then((resp) => {
        if (resp.data) {
          // onAction();
          dispatch(setSahraConnectionsTableFetchDataFlag(true));

          setCaptcha("");
        } else toast.error(resp.msg);
      })
      .catch(() => toast.error("عدم ارتباط با سرور"))
      .finally(() => setLoading(false));
  };

  const enterCaptchaHandler = () => {
    setLoading(true);
    enterCaptcha(row.id, captcha)
      .then((resp) => {
        if (resp.data) {
          // onAction();
          dispatch(setSahraConnectionsTableFetchDataFlag(true));
          toast.success(resp.msg);
        }
        if (!resp.data) toast.error(resp.msg);
      })
      .catch(() => toast.error("عدم ارتباط با سرور"))
      .finally(() => setLoading(false));
  };

  const logoutConnectionHandler = () => {
    setLoading(true);
    logoutConnection(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          // onAction();
          dispatch(setSahraConnectionsTableFetchDataFlag(true));
        }
        if (!resp.data) toast.error(resp.msg);
      })
      .catch(() => toast.error("عدم ارتباط با سرور"))
      .finally(() => setLoading(false));
  };
  const checkConncetionHandler = () => {
    setLoading(true);
    checkConnection(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          // onAction();
          dispatch(setSahraConnectionsTableFetchDataFlag(true));
        }
        if (!resp.data) toast.error(resp.msg);
      })
      .catch(() => toast.error("عدم ارتباط با سرور"))
      .finally(() => setLoading(false));
  };

  const captchaKeyDownHandler = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") enterCaptchaHandler();
  };

  const getCanTradeProperFunction = () => {
    if (row.canTrade) return disableSahraUserTrade(row.id);
    return enableSahraUserTrade(row.id);
  };

  const canTradeChangeHandler = () => {
    getCanTradeProperFunction()
      .then((res) => {
        if (res.data) {
          toast.success(res.msg);
          onAction();
        } else toast.error(res.msg);
      })
      .catch(packetErrorHandler);
  };

  return (
    <>
      <TableCell>
        {row.connectionStatus === ConnectionStatus.Online ? (
          <div>مانده: {time}</div>
        ) : (
          row.time
        )}
      </TableCell>
      <TableCell>
        {row.imageAddress ? (
          <div className="w-16 h-6 mb-px">
            <img src={`${apiAddress()}/v1/captcha/${row.imageAddress}`} />
          </div>
        ) : (
          <div>-</div>
        )}
      </TableCell>
      <TableCell>
        <div onClick={getNewCaptchaHandler}>
          <CachedIcon fontSize="inherit" className="cursor-pointer" />
        </div>
      </TableCell>
      <TableCell>
        {loading ? <FullScreenLoading /> : null}
        {row.imageAddress ? (
          <div className="w-24 h-5 m-1">
            <SimpleTextInput
              placeholder="کپچا"
              name="captcha"
              onChange={(name, value) => setCaptcha(value)}
              value={captcha}
              className="text-xs"
              onKeyDown={captchaKeyDownHandler}
              onMouseDown={() => false}
            />
          </div>
        ) : null}
      </TableCell>
      <TableCell>
        <div className="flex flex-row gap-1 w-min">
          <Button
            disabled={row.imageAddress ? false : true}
            className="table-btn"
            onClick={enterCaptchaHandler}
            text="ارسال"
            variant="contained"
          />
          {row.connectionStatus !== ConnectionStatus.Offline ? (
            <>
              <Button
                className="table-btn"
                onClick={logoutConnectionHandler}
                text="قطع"
                variant="contained"
              />
              <Button
                className="table-btn"
                onClick={checkConncetionHandler}
                text="تست"
                variant="contained"
              />
            </>
          ) : null}
        </div>
      </TableCell>
      <TableCell>{row.captchaMsg}</TableCell>
      <TableCell>
        <ToggleSwitch
          checked={row.canTrade}
          label=""
          name=""
          onChange={canTradeChangeHandler}
        />
      </TableCell>
    </>
  );
};

export const ConnectionTableAdditional: IAdditional<IConnectionsReport> = {
  getHeader: ConnectionTableAdditionalHeader,
  getRow: SahraUsersAdditionalCol,
};
